import { render, staticRenderFns } from "./CreateTemplateMessage.vue?vue&type=template&id=47e7dea8&scoped=true&"
import script from "./CreateTemplateMessage.vue?vue&type=script&lang=js&"
export * from "./CreateTemplateMessage.vue?vue&type=script&lang=js&"
import style0 from "./CreateTemplateMessage.vue?vue&type=style&index=0&id=47e7dea8&lang=scss&scoped=true&"
import style1 from "./CreateTemplateMessage.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e7dea8",
  null
  
)

export default component.exports